import React from "react";

interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  text: string;
}

const Button = ({ text, disabled, type }: ButtonProps) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className="w-2/3 from-[#FCF512] to-[#FCF512] text-[#FF0000] font-bold py-2 rounded-full bg-gradient-to-b hover:from-[#FFD400] hover:to-[#FFAE00] hover:text-white"
    >
      {text}
    </button>
  );
};

export default Button;
